import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var RoleService = /** @class */ (function (_super) {
    tslib_1.__extends(RoleService, _super);
    function RoleService(http) {
        var _this = _super.call(this, http, MapperService.roleMap) || this;
        _this._endpoint = '/odata/Roles';
        _this.suggest = function (searchTerm, fetchSize, skip, _a) {
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var useId = (_a === void 0 ? { useId: false } : _a).useId;
            var queryOptions = {
                orderBy: ['Name'],
                top: fetchSize,
                skip: skip,
            };
            if (searchTerm) {
                queryOptions.filter = {
                    DisplayName: {
                        contains: searchTerm,
                    },
                };
            }
            return _this.get(queryOptions)
                .pipe(map(function (_a) {
                var data = _a.data, total = _a.total;
                return ({
                    total: total,
                    data: data.map(function (role) { return ({
                        id: useId ? role.id : role.name,
                        text: role.name,
                    }); }),
                });
            }));
        };
        return _this;
    }
    RoleService.prototype.getUsersIn = function (roleId, queryOptions) {
        var _this = this;
        return this._http.get(this._endpoint +
            ("/UiPath.Server.Configuration.OData.GetUsersForRole(key=" + roleId + ")" + this.getQueryString(queryOptions)))
            .pipe(map(function (res) { return _this._mapData(res, MapperService.userMap); }));
    };
    RoleService.prototype.getUserIdsForRole = function (roleId) {
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetUserIdsForRole(key=" + roleId + ")";
        return this._http
            .get(endpoint)
            .pipe(map(function (data) { return data.value.map(function (id) { return ({ id: id }); }); }));
    };
    RoleService.prototype.setUsers = function (roleId, _a) {
        var add = _a.add, remove = _a.remove;
        var payload = {
            addedUserIds: add.map(function (e) { return e.id; }),
            removedUserIds: remove.map(function (e) { return e.id; }),
        };
        return this._http.post(this._endpoint + "(" + roleId + ")/UiPath.Server.Configuration.OData.SetUsers", JSON.stringify(payload));
    };
    return RoleService;
}(ODataService));
export { RoleService };
